import { RadioGroup } from "@headlessui/react";
import {
  CheckCircleIcon,
  PlusCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const mailingLists = [
  {
    id: 1,
    title: "Bikes & Rolling Chassis",
    description: "",
    // description: "Dieser Artikel wird einmalig berechnet",
    // users: "50€ pro Inserat",
    users: "KOSTENLOS",

    value: "rollingchassis",
    oem: "Aftermarket",
  },
];

function BikesForm() {
  const IMAGE_LIMIT = 2; // Limit for the number of images

  const [artikelName, setArtikelName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [teileCode, setTeileCode] = useState("OEM");
  const [partsNumber, setPartsNumber] = useState("");
  const [codeString, setCodeString] = useState([]);
  const [category, setCategory] = useState("reifen");

  const [selectedManufacturer, setSelectedManufacturer] =
    useState("harley-davidson");

  const [zustand, setRadioValue] = useState("Neu");

  const [productFee, setProductFee] = useState("0.00");
  const [msg, setMsg] = useState("");
  const [selectedMailingLists, setSelectedMailingLists] = useState(
    mailingLists[0]
  );

  const [baujahr, setBaujahr] = useState("");
  const [motor, setMotor] = useState("");
  const navigate = useNavigate();

  const [emailCheck, setEmailCheck] = useState("");
  const [telefonCheck, setTelefonCheck] = useState("");
  const initialOptions = ["OEM", "MCS", "CCE", "Zodiac", "PE"];
  const [options, setOptions] = useState(initialOptions);

  const [isAdding, setIsAdding] = useState(false);
  const [newOption, setNewOption] = useState("");
  const [imageMsg, setImageMsg] = useState("");
  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length + files.length > IMAGE_LIMIT) {
      setImageMsg(`Sie können maximal ${IMAGE_LIMIT} Bilder hochladen.`);
      return;
    }

    const updatedFiles = [...files, ...selectedFiles];
    setFiles(updatedFiles);

    const selectedImages = selectedFiles.map((file) =>
      URL.createObjectURL(file)
    );
    const updatedImages = [...images, ...selectedImages];
    setImages(updatedImages);
    setImageMsg(""); // Clear any previous messages
  };
  const handleRemoveImage = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    const updatedImages = images.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    setImages(updatedImages);
    setImageMsg(""); // Clear any previous messages
  };
  const setTeilenummer = () => {
    if (teileCode === "" || partsNumber === "") {
      setMsg("Bitte Typ und Nummer auswählen");
      return;
    }
    setMsg("");
    setCodeString([...codeString, teileCode + " - " + partsNumber]);

    setTeileCode("OEM");
    setPartsNumber("");
  };

  const removeCode = (e, id) => {
    e.preventDefault();
    let array = [...codeString]; // make a separate copy of the array
    if (id !== -1) {
      array.splice(id, 1);
      setCodeString(array);
    }
  };

  const handlePrice = (e) => {
    let converted = e.replace(",", ".");
    let price = parseFloat(converted);

    setPrice(converted);

    // switch (selectedMailingLists.value) {
    //   case "originalparts":
    //     setProductFee((price * 0.05).toFixed(2));
    //     break;
    //   case "rollingchassis":
    //     setProductFee("50");
    //     break;
    //   case "customparts":
    //     setProductFee("Xx mtl.");
    //     break;
    //   default:
    //     setProductFee((price * 0.05).toFixed(2));
    //     break;
    // }
    switch (selectedMailingLists.value) {
      case "originalparts":
        setProductFee((price * 0.0).toFixed(2));
        break;
      case "rollingchassis":
        setProductFee("0");
        break;
      case "customparts":
        setProductFee("0");
        break;
      default:
        setProductFee((price * 0.0).toFixed(2));
        break;
    }
  };
  const PostProduct = async (e) => {
    e.preventDefault();

    let formData = new FormData();
    formData.append("artikelName", artikelName);
    formData.append("description", description);
    files.forEach((file, index) => {
      formData.append(`files`, file); // Ensure this key matches the one expected by your backend
    });
    formData.append("partsNumber", partsNumber);
    formData.append("price", price);
    formData.append("selectedManufacturer", selectedManufacturer);
    formData.append("codeListe", codeString);
    formData.append("zustand", zustand);
    formData.append("motor", motor);
    formData.append("category", category);
    formData.append("baujahr", baujahr);
    formData.append("selector", "bikes");
    formData.append("type", "rollingchassis");
    formData.append("contactPreferenceTelefon", telefonCheck);
    formData.append("contactPreferenceEmail", emailCheck);

    try {
      await axios
        .post(`https://dealersonly.parts/beta/api/user/products/new`, formData)
        .then((res) => {
          navigate("../");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      setMsg(error.response.data);
    }
  };
  useEffect(() => {
    axios
      .get(`https://dealersonly.parts/beta/api/user/productsCode/TeileCodes`)
      .then((res) => {
        const fetchedOptions = res.data;

        // Combine initial options with fetched options and remove duplicates
        const newOptions = Array.from(new Set([...options, ...fetchedOptions]));

        // Update state with new options
        setOptions(newOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value === "add-new") {
      setIsAdding(true);
    } else {
      setTeileCode(value);
      setIsAdding(false);
    }
  };
  const handleConfirmNewOption = () => {
    let capitalizedOption = newOption.toUpperCase();
    if (capitalizedOption && !options.includes(capitalizedOption)) {
      setOptions((prev) => [...prev, capitalizedOption]);
      setTeileCode(capitalizedOption);
    }
    setIsAdding(false);
    setNewOption("");
  };

  const handleCancelNewOption = () => {
    setIsAdding(false);
    setNewOption("");
  };
  return (
    <form onSubmit={PostProduct}>
      <div className="overflow-hidden shadow sm:rounded-md">
        <div className="bg-white px-4 py-5 sm:p-6">
          {msg && (
            <div className="rounded-md bg-red-50 p-4 mb-2">
              <div className="flex">
                <div className="flex-shrink-0">
                  <XCircleIcon
                    className="h-5 w-5 text-red-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">
                    Fehler beim erstellen des Artikels
                  </h3>
                  <div className="mt-2 text-sm text-red-700">
                    <ul role="list" className="list-disc space-y-1 pl-5">
                      <li>{msg}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 sm:col-span-6">
              <RadioGroup
                value={selectedMailingLists}
                onChange={setSelectedMailingLists}
              >
                <RadioGroup.Label className="text-base font-medium text-gray-900">
                  Welcher Artikel soll eingestellt werden
                </RadioGroup.Label>

                <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-1 sm:gap-x-4">
                  {mailingLists.map((mailingList) => (
                    <RadioGroup.Option
                      key={mailingList.id}
                      value={mailingList}
                      className={({ checked, active }) =>
                        classNames(
                          checked ? "border-transparent" : "border-gray-300",
                          active
                            ? "border-indigo-500 ring-2 ring-indigo-500"
                            : "",
                          "relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none"
                        )
                      }
                    >
                      {({ checked, active }) => (
                        <>
                          <span className="flex flex-1">
                            <span className="flex flex-col">
                              <RadioGroup.Label
                                as="span"
                                className="block text-sm font-medium text-gray-900"
                              >
                                {mailingList.title}
                              </RadioGroup.Label>
                              <RadioGroup.Description
                                as="span"
                                className="mt-1 flex items-center text-sm text-gray-500"
                              >
                                {mailingList.description}
                              </RadioGroup.Description>
                              <RadioGroup.Description
                                as="span"
                                className="mt-6 text-sm font-medium text-gray-900"
                              >
                                {mailingList.users}
                              </RadioGroup.Description>
                            </span>
                          </span>
                          <CheckCircleIcon
                            className={classNames(
                              !checked ? "invisible" : "",
                              "h-5 w-5 text-indigo-600"
                            )}
                            aria-hidden="true"
                          />
                          <span
                            className={classNames(
                              active ? "border" : "border-2",
                              checked
                                ? "border-indigo-500"
                                : "border-transparent",
                              "pointer-events-none absolute -inset-px rounded-lg"
                            )}
                            aria-hidden="true"
                          />
                        </>
                      )}
                    </RadioGroup.Option>
                  ))}
                </div>
              </RadioGroup>
            </div>

            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="first-name"
                className="block text-sm font-medium text-gray-700"
              >
                Bike Name
              </label>
              <input
                type="text"
                name="artikelName"
                id="artikelName"
                autoComplete="product-name"
                value={artikelName}
                onChange={(e) => setArtikelName(e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>

            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="country"
                className="block text-sm font-medium text-gray-700"
              >
                Rahmen/Modell
              </label>
              <select
                id="category"
                name="category"
                autoComplete="category-name"
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                defaultValue={""}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option disabled value="">
                  Bitte wählen
                </option>
                <option value="Flathead">Flathead</option>
                <option value="Knucklehead">Knucklehead</option>
                <option value="Panhead">Panhead</option>
                <option value="K-Modelle">K-Modelle</option>
                <option value="XL-Ironhead">XL-Ironhead</option>
                <option value="Early-Shovel">Early-Shovel</option>
                <option value="Shovelhead">Shovelhead</option>
                <option value="Evolution">Evolution</option>
                <option value="XL-Evolution">XL-Evolution</option>
                <option value="Twin-Cam">Twin-Cam</option>
                <option value="M8">M8</option>
              </select>
            </div>

            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="country"
                className="block text-sm font-medium text-gray-700"
              >
                Baujahr
              </label>
              <input
                id="number"
                name="baujahr"
                autoComplete="baujahr"
                maxLength={4}
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                value={baujahr}
                placeholder="1990"
                onChange={(e) => setBaujahr(e.target.value)}
              />
            </div>

            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="company-website"
                className="block text-sm font-medium text-gray-700"
              >
                Motorisierung
              </label>
              <div className="mt-1 flex rounded-md shadow-sm">
                <input
                  type="text"
                  name="motorisierung"
                  id="motorisierung"
                  className="block w-full flex-1 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Motorbezeichnung"
                  value={motor}
                  onChange={(e) => setMotor(e.target.value)}
                />
              </div>
            </div>

            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="about"
                className="block text-sm font-medium text-gray-700"
              >
                Zusätzliche Beschreibung
              </label>
              <div className="mt-1">
                <textarea
                  id="description"
                  name="description"
                  rows={3}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Bitte so ausführlich wie möglich beschreiben. Besonderheiten, Un/Umfallschäden, Details finden hier Platz."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <p className="mt-2 text-sm text-gray-500">
                Freitext für Informationen die kein eigenes Feld haben.
              </p>
            </div>

            <div className="col-span-6">
              <fieldset>
                <label className="text-sm font-medium text-gray-700">
                  In welchem Zustand befindet sich der Artikel?
                </label>
                <div className="mt-4 space-y-4">
                  <div className="flex items-center">
                    <input
                      id="push-everything"
                      name="push-notifications"
                      type="radio"
                      value="Neu"
                      checked={zustand === "Neu"}
                      onChange={(e) => setRadioValue(e.currentTarget.value)}
                      className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      htmlFor="push-everything"
                      className="ml-3 block text-sm font-medium text-gray-700"
                    >
                      Neu
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="push-email"
                      name="push-notifications"
                      type="radio"
                      value="Gebraucht"
                      checked={zustand === "Gebraucht"}
                      onChange={(e) => setRadioValue(e.currentTarget.value)}
                      className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                      htmlFor="push-email"
                      className="ml-3 block text-sm font-medium text-gray-700"
                    >
                      Gebraucht
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                Artikelfoto
              </label>
              <div className="mt-1 flex flex-col justify-center items-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-gray-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="flex text-sm text-gray-600">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500"
                    >
                      <span>Bild hochladen</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        onChange={handleFileChange}
                        multiple
                        accept="image/png, image/jpeg"
                        className="sr-only"
                      />
                    </label>
                  </div>
                  <p className="text-xs text-gray-500">PNG, JPG bis 10MB</p>
                </div>
                <div className="flex flex-wrap mt-4 w-full">
                  {images.map((image, index) => (
                    <div key={index} className="relative w-1/4 p-2">
                      <img
                        className=" w-full"
                        src={image}
                        alt={`preview image ${index + 1}`}
                      />
                      <button
                        type="button"
                        className="absolute top-2 right-2 m-2  bg-white rounded-full text-red-500 hover:text-red-700 focus:outline-none"
                        onClick={() => handleRemoveImage(index)}
                      >
                        <XCircleIcon className="h-5 w-5" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              {imageMsg && (
                <h3 className="text-sm font-medium text-yellow-800">
                  {imageMsg}
                </h3>
              )}
            </div>

            <div className="col-span-6">
              <fieldset>
                <legend className="text-sm font-semibold leading-6 text-gray-900">
                  Kontaktmöglichkeit (mindestens 1)
                </legend>
                <p className="text-sm leading-6 text-gray-500">
                  Wird nur für diesen Artikel übernommen.
                </p>

                <div className="mt-3 grid grid-cols-12 gap-6">
                  <div className="col-span-6">
                    <label
                      htmlFor="mail"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Per Mail
                    </label>
                    <input
                      type="text"
                      name="mail"
                      id="mail"
                      value={emailCheck}
                      onChange={(e) => setEmailCheck(e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      htmlFor="telefon"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Per Telefon
                    </label>
                    <input
                      type="text"
                      name="telefon"
                      id="telefon"
                      autoComplete="product-name"
                      value={telefonCheck}
                      onChange={(e) => setTelefonCheck(e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-span-6 sm:col-span-6 lg:col-span-6">
              <label
                htmlFor="postal-code"
                className="block text-sm font-medium text-gray-700"
              >
                Artikelpreis
              </label>
              <input
                type="text"
                name="preis"
                id="preis"
                value={price}
                onChange={(e) => {
                  handlePrice(e.target.value);
                }}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Artikel für {formatter.format(productFee)} erstellen
          </button>
        </div>
      </div>
    </form>
  );
}

export default BikesForm;
